import { render, staticRenderFns } from "./RightContent.vue?vue&type=template&id=1cc6f470&scoped=true&"
import script from "./RightContent.vue?vue&type=script&lang=js&"
export * from "./RightContent.vue?vue&type=script&lang=js&"
import style0 from "./RightContent.vue?vue&type=style&index=0&id=1cc6f470&prod&lang=scss&"
import style1 from "./RightContent.vue?vue&type=style&index=1&id=1cc6f470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc6f470",
  null
  
)

export default component.exports